module.exports = __webpack_public_path__ + "img/vanessa.63dba6f0.jpg";